<template>
  <div class="modal-card" style="width: 600px">
    <header class="modal-card-head">
      <p class="modal-card-title">Share link</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <b-loading :is-full-page="false" v-model="loading" :can-cancel="true" />
      <p>This link will grant temporary access to someone without a YourStake account to view this report.</p>
      <br>
      <b-field label="Link" grouped type="is-info">
        <b-input
          type="text"
          readonly
          expanded
          @focus="$event.target.select()"
          v-model="link"
        >
        </b-input>

        <p class="control">
        <b-tooltip 
            type="is-primary"
            :triggers="['click']"
            :auto-close="['outside', 'escape']">
            <template v-slot:content>
              <p>Copied!</p>
            </template>
          <b-button
            @click="copyShareLink"
            icon-pack="fas"
            icon-right="copy"
            v-bind:class="{ 'is-info': !clicked, 'is-success': clicked }"
          >
          </b-button>
          </b-tooltip>
        </p>
      </b-field>
      <p>Expires: {{ expires }}</p>
    </section>
    <footer class="modal-card-foot">
      <b-button label="Close" @click="$emit('close')" />
    </footer>
  </div>
</template>

<script>
import { apiFetch } from '../../../../../api/api';

export default {
  data() {
    return {
      loading: false,
      link: '',
      clicked: false,
      expires: '',
    }
  },
  props: {
    reportUrl: String,
    portfolio: Object,
    renderedReportId: Number
  },
  watch: {
  },
  methods: {
    fetchLink: async function() {
      this.loading = true;

      let response = await apiFetch(
        `/api/v1/process/report/shareable_institutional_link/`,
        {
          method: 'POST',
          headers: {
            'X-CSRFToken': this.$root.$data.csrfToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            portfolio_id: this.portfolio.external_id || this.portfolio.id,
            report_url: this.reportUrl,
            rendered_report_id: this.renderedReportId,
            scope: 'view-report'
          })
        }
      );
      let data = await response.json();
      this.link = data.share_link;
      this.expires = data.expires;
      this.loading = false;
    },
    copyShareLink: async function() {
      await navigator.clipboard.writeText(this.link);
      this.clicked = true;
    }
  },
  mounted: function() {
    this.fetchLink();
  }
}
</script>

